// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { mainNavigationStyles } from "@guestsupply/Overrides/Widgets/Header/MainNavigation";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

mainNavigationStyles.itemsContainerStyledWrapper = {
    css: css`
        display: flex;
        justify-content: left;
    `,
};
mainNavigationStyles.container = {
    css: css`
        color: ${getColor("common.background")};
        display: flex;
        /* justify-content: space-between; */
    `,
};
mainNavigationStyles.itemWrapper = {
    css: css`
        position: relative;
        overflow: visible;
        display: flex;
        &:hover span + div {
            display: block;
        }
        /* padding: 0 16px; */
        /* &:last-child {
            padding-right: 0;
        }
        &:first-child {
            padding-left: 0;
        } */
    `,
};
